const Style = {

  wrapper: 'h-24',
  nav: 'absolute top-1/2 -translate-y-1/2 right-0',
  logo: 'absolute top-1/2 -translate-y-1/2 left-0 m0',
  transparent: 'bg-none bg-transparent',
  color: 'bg-brand-800',
  link: 'mr-5 last:mr-0 no-underline',
  button: 'inline-block',

}

export default Style;